/* **The MoveBuddy mark — the brand asset, never a drawing of it.**
 *
 * A stylesheet with no component, like `emberButton.module.css` and `MenuSurface.module.css` beside
 * it. A component would have to take the size as a prop, and this is one `<span>` on every surface.
 *
 * ── Why this file exists ─────────────────────────────────────────────────────────────────────
 * The invite ticket shipped a HAND-DRAWN `<svg>` of the mark — a stroked wave and a dot, authored
 * from the KANON specimen rather than taken from the brand. That is banned outright: the app never
 * draws its own graphics when an asset exists, and a second drawing of a logo is a second logo.
 * `AuthShell` had the correct construction already and was its only consumer, so on the second one
 * the treatment moves here, which is the house rule for a repeated declaration block.
 *
 * ── It is a MASK, and that is what makes it theme-adaptive from ONE file ─────────────────────
 * `public/brand/mark.png` is the canonical silhouette — the same artwork as the mobile app's
 * `assets/auth/mark-black.png`, transparent background, monochrome. Masking it and filling with
 * `--text` reproduces BOTH of the mobile variants exactly: `--text` is `--ink-900` on Flame and
 * white on Flame Dark, which are `mark-black.png` and `mark-white.png` respectively.
 *
 * So there is no second file to keep in sync, no theme branching in any stylesheet, and no
 * two-`<img>`-and-hide-one construction in the markup. A third theme costs nothing, and the
 * "always white over the photograph" rule the auth screens need is one `background-color`.
 *
 * ── How a surface uses it ────────────────────────────────────────────────────────────────────
 * Two classes on the element: this one for the TREATMENT, and the surface's own for the SIZE, which
 * is the only thing that varies — the auth lockup is `--brand-mark`, the invite ticket's is 20px.
 * A surface must not restate `background-color` or any of the four mask properties.
 *
 * ── `--mark-ink`, for the one surface that needs the mark to be a HOLE ───────────────────────
 * Added 17.09.2026 on the exercise library's author circle, which is a disc of `--text` with the
 * mark cut out of it (owner decision D5: the original mark, on an ink circle, never a letter). The
 * mark there has to paint `--bg`, and a second stylesheet restating `background-color` would be
 * settled by chunk order — which differs between the dev server and the build, and this repo has
 * paid for that once. So the surface states a VARIABLE and this file states the property, the same
 * split `scrollbar.module.css`'s `--sb-size` and `AvatarChip`'s `--sz-avatar` already use. The
 * fallback is the ink every other consumer wants, so nothing else changes.
 */

.brandMark {
  flex: none;
  background-color: var(--mark-ink, var(--text));
  mask-image: url("/brand/mark.png");
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
}
